var map = {
	"./level-1.png": "bHsB",
	"./level-2.png": "RcoR",
	"./level-3.png": "JqHm",
	"./level-4.png": "ktA8",
	"./level-5.png": "fbaB",
	"./level-6.png": "2yl6",
	"./level-7.png": "fM9i",
	"./level-8.png": "Kz7B",
	"./level-9.png": "5AD3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "duTb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cert ^\.\/level\-.*\.png$
// module id = duTb
// module chunks = 126